import {
  CartesianGrid,
  ComposedChart,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import AnalyticsTooltip from "src/components/Referral-partner/Analytics/AnalyticsTooltip";
import { TimeSeriesDataPoint } from "src/components/Referral-partner/Analytics/analyticsTypes";
import {
  AXIS_STYLES,
  GRID_STYLES,
} from "src/components/Referral-partner/Analytics/styles/chart.styles";

interface CustomerTradingActivityProps {
  data: TimeSeriesDataPoint[];
}

export const CustomerTradingActivity = (props: CustomerTradingActivityProps) => {
  const { data } = props;
  return (
    <ResponsiveContainer id="trading-history-chart" height="80%" width="95%">
      <ComposedChart data={data} margin={{ top: 20, right: 10 }}>
        <CartesianGrid vertical={false} {...GRID_STYLES} />
        <XAxis dataKey="timestamp" {...AXIS_STYLES} />
        <YAxis {...AXIS_STYLES} />
        <Tooltip content={<AnalyticsTooltip />} />
        <Line
          type="monotone"
          dataKey="Buy Orders"
          stroke="#ffae58"
          strokeWidth={2}
          opacity={0.8}
          dot={false}
        />
        <Line
          type="monotone"
          dataKey="Sell Orders"
          stroke="#e66d79"
          strokeWidth={2}
          opacity={0.8}
          dot={false}
        />
        <Line
          type="monotone"
          dataKey="Target Orders"
          stroke="#61c0eb"
          strokeWidth={2}
          opacity={0.8}
          dot={false}
        />
        <Line
          type="monotone"
          dataKey="Trade Orders"
          stroke="#a1a1ea"
          strokeWidth={2}
          opacity={0.8}
          dot={false}
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
};
